<template>
  <div class="flex items-center gap-0.5 w-max relative">
    <div class="slider slider-low" />
    <div class="slider-divider" />
    <div class="slider slider-high" />
    <!-- Marker -->
    <div
      class="absolute top-0 bottom-0 my-auto marker"
      :class="markerClass"
      :style="{ left: `${markLocation}px`, width: markerWidth }"
    >
    </div>
  </div>
</template>

<script>
export default {
  name: 'PercentageChangeSlider',
  props: {
    range: {
      type: Number,
      default: () => 100
    },
    value: {
      type: Number,
      default: () => 0
    },
    isReverse: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const fullWidth = 75
    const markerWidth = 5
    return {
      fullWidth,
      markerWidth
    }
  },
  computed: {
    markerClass () {
      if (this.markLocation > this.fullWidth / 2) {
        return 'marker-positive'
      }
      return 'marker-neutral'
    },
    markLocation () {
      let xPos = ((this.value + this.range) / (2 * this.range)) * this.fullWidth;
      if (this.isReverse) {
      const midPoint = this.fullWidth / 2;
      xPos = midPoint + (midPoint - xPos);
      }
      xPos = xPos - this.markerWidth / 2;
      return Math.max(0, Math.min(75, xPos));
    }
  }
}
</script>

<style scoped>
.slider-divider{
  height: 3px;
  width: 3px;
  border-radius: 3px;
  background-color: #303546;
}
.slider{
  height: 3px;
  width: 34px;
  border-radius: 3px;
}
.slider-low{
  background-color: #C1C7D0;
}
.slider-high{
  background-color: #40C4AA;
}
.marker{
  width: 6px;
  border-radius: 4px;
  height: 14px;
}
.marker-positive{
  background-color: #fff;
  border: 2px solid #40C4AA;
}
.marker-neutral{
  background-color: white;
  border: 2px solid #C1C7D0;
}
</style>
